import React, { useEffect, useState } from "react";
import "./Photogallery.css";
import { Slide } from "react-awesome-reveal";
import axios from "axios";

function Photogallery() {
  const [images, setImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState({}); // loader state

  useEffect(() => {
    axios
      .get("https://himchatterjee.in/backend/fetch_photos.php")
      .then((res) => {
        //  console.log("Photo API response:", res.data); // <-- yeh line add karein
        setImages(res.data);

        // Initialize loader state
        const initialLoading = {};
        res.data.forEach((item) => {
          initialLoading[item.id] = true;
        });
        setLoadingImages(initialLoading);
      })
      .catch((err) => {
        console.error("Error fetching photos:", err);
      });
  }, []);

  const handleImageLoad = (id) => {
    setLoadingImages((prev) => ({ ...prev, [id]: false }));
  };

  return (
    <div className="food_thirdCard">
      <h1>PHOTO GALLERY</h1>
      <div className="food_thirdCard2">
        {images.map((item, index) => (
          <Slide
            key={item.id}
            direction={
              index % 4 === 0
                ? "left"
                : index % 4 === 1
                ? "right"
                : index % 4 === 2
                ? "up"
                : "down"
            }
            triggerOnce={false}
            duration={800}
            delay={index * 100}
          >
            <div className="food_thirdC3">
              <div className="media-container">
                {/* Loader overlay */}
                {loadingImages[item.id] && (
                  <div className="media-loader-overlay">
                    <div className="loader"></div>
                  </div>
                )}

                <img
                  src={item.src}
                  alt={item.title}
                  onLoad={() => handleImageLoad(item.id)}
                  style={{ display: loadingImages[item.id] ? "none" : "block" }}
                />

                <div className="Fcard-body3">
                  <p>{item.title}</p>
                </div>
              </div>
            </div>
          </Slide>
        ))}
      </div>
    </div>
  );
}

export default Photogallery;
